export const LIKE_REVIEW = 'LIKE_REVIEW'
export const UNLIKE_REVIEW = 'UNLIKE_REVIEW'

// ambassador feed reviews
export const FETCHING_REVIEWS_AMBASSADOR_INITIAL =
  'FETCHING_REVIEWS_AMBASSADOR_INITIAL'
export const RECEIVED_REVIEWS_AMBASSADOR_INITIAL =
  'RECEIVED_REVIEWS_AMBASSADOR_INITIAL'
export const ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL =
  'ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL'
export const FETCHING_REVIEWS_AMBASSADOR_MORE =
  'FETCHING_REVIEWS_AMBASSADOR_MORE'
export const RECEIVED_REVIEWS_AMBASSADOR_MORE =
  'RECEIVED_REVIEWS_AMBASSADOR_MORE'
export const ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE =
  'ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE'
